import React, { useContext } from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import type { ParticipantListProps, StandupActions } from './src/common/types.tsx';
import { StandupEntryPointContext } from './src/controllers/context-provider/index.tsx';
import { LoadingStandupPanel } from './src/ui/loading-standup-panel/index.tsx';

export const AsyncJiraStandups = (props: ParticipantListProps & StandupActions) => {
	const { entryPointReferenceSubject } = useContext(StandupEntryPointContext);

	return (
		<JiraEntryPointContainer
			id="jira-rituals-standups"
			packageName="jiraRitualsStandups"
			fallback={<LoadingStandupPanel />}
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={props}
		/>
	);
};
